import validators from '../validators';

import { SANDBOX_DATA_KEYS as DATA_KEYS } from './dataKeys';

export const USER_SCHEMA = {
    [DATA_KEYS.ALLOW_SANDBOX1_ACCESS]: validators.yesNo
};

export const USER_HEADER_MAPPING = {
    [DATA_KEYS.ALLOW_SANDBOX1_ACCESS]: 'Allow Sandbox1 Access'
};
